import React, { useState } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../../Components/UI/spinner";
import HeaderBar from "../../../Components/UI/headerbar";
import { shippingStatsConfig, tabs } from "./config";
import ShippingStatusCard from "../../../Components/shippings/shipping";
import { showStores } from "../../../MyApi/stores";
import ShippingAttachments from "../../../Components/shippings/shippingAttachments";
import CompanyInfo from "../../../Components/shippings/companyInfo";
import StatsCard from "../../../Components/UI/staticsCard";
import ShiftsTable from "../../../Components/shippings/shifts";
import CuriorDeliveryCompany from "../../../Components/shippings/curioer";
import PerformanceReports from "../../../Components/shippings/preformancereports";
import { showDeliveryStore } from "../../../MyApi/delivery";
import ZonesToCover from "../../../Components/shippings/zonesToCovet";
import TransactionsInfo from "../../../Components/shippings/transactionsInfo";

const ShippingShowPage = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("attachments");
  const [isModalOpen,setIsModalOpen]=useState(false)
  const { data, isLoading, refetch } = useQuery("showDelivery", () =>
    showDeliveryStore(id)
  );

  const delivery = data?.data?.store || {};
  const {
    name,
    status,
    status_label,
    note,
    logo,
    cover_image,
    phone,
    address,
currency_factor,
    is_featured,
    is_active,
    is_closed,
    is_favorite,
    avg_rate,
  } = delivery;
  const delivery_stats =data?.data?.delivery_stats ||{}
  const performance_reports =data?.data?.performance_reports ||{}
  const quick_stats =data?.data?.quick_stats ||{}
  const achievements =data?.data?.achievements ||{}
  const delivery_chart= data?.data?.delivery_chart ||{}
  const companyStats = shippingStatsConfig(delivery_stats ,currency_factor);

  const shiftsData = [
  {
    name: "مسائي",
    start: "18:45",
    end: "00:30",
    duration: "8h",
    breakTime: "45 دقيقة",
  },
  {
    name: "صباحي",
    start: "18:45",
    end: "00:30",
    duration: "8h",
    breakTime: "45 دقيقة",
  },
  {
    name: "نصف اليوم",
    start: "18:45",
    end: "00:30",
    duration: "8h",
    breakTime: "45 دقيقة",
  },
  {
    name: "بعد الظهر",
    start: "18:45",
    end: "00:30",
    duration: "8h",
    breakTime: "45 دقيقة",
  },
];


const openModal=()=>{
  setIsModalOpen(true)
}
const closeModal =()=>{
  setIsModalOpen(false)
}



  if (isLoading) {
    return <LoadingSpinner />;
  }
  return (
    <div>
      <HeaderBar
        title={"تفاصيل شركة الشحن"}
        content={"عرض وإدارة معلومات شركة الشحن"}
        isBack={true}
      />

      <ShippingStatusCard
        logo={logo}
        status={status}
        name={name}
        avg_rate={avg_rate}
        statusApi={is_active}
        refetch={refetch}
        id={id}
      />
      <div className="row">
        {companyStats.map((stats, i) => (
          <div className="col-md" key={i}>
            <StatsCard {...stats} />
          </div>
        ))}
      </div>

      <div className="card rounded-3 shadow-sm ">
        <div className="card-body">
          <div className="rounded-4 bg-smoke p-2 px-3">
            <ul className="row">
              {tabs.map((tab) => (
                <li
                  className={`col-md text-center p-2 ${
                    activeTab === tab.label ? "bg-white rounded-4" : ""
                  }`}
                  key={tab.id}
                  onClick={() => setActiveTab(tab.label)}
                >
                  {tab.name}
                </li>
              ))}
            </ul>
          </div>
          <div className="mt-3">
            {activeTab === "attachments" && (
              <ShippingAttachments status={status} logo={logo} id={id} refetch={refetch} />
            )}
            {activeTab === "companyInfo" && (
              <CompanyInfo
                name={name}
                phone={phone}
                address={address}
                avg_rate={avg_rate}
                is_active={is_active}
                quick_stats={quick_stats}
                achievements={achievements}
                delivery_chart={delivery_chart}
              />
            )}

            {activeTab === "workingDays" && (
              <ShiftsTable shifts={shiftsData} id={id} openModal={openModal} closeModal={closeModal} isModalOpen={isModalOpen}/>
            )}
            {activeTab ==="curioer" && <CuriorDeliveryCompany id={id}/>}

            {activeTab ==="reports" && <PerformanceReports performance_reports={performance_reports} delivery_stats={delivery_stats}/>}
            {activeTab ==="zones" && <ZonesToCover  id={id}/>}   
            {activeTab ==="transactions" && <TransactionsInfo id={id}/>}   
            
          </div>
        </div>   
      </div>
    </div>
  );
};

export default ShippingShowPage;
